import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { ParticipanteI } from './ParticipanteModal'
import { formatDateHourMinute } from '../../utils/strings'

const useExcelExportRegistro = (participantes: ParticipanteI[]) => {

    const exportToExcel = () => {
        const data = participantes.map(p => ({
            'Código': p.codigoRegistro,
            'Nombre': p.nombreProfesor,
            'Email': p.email,
            'Edad': p.edad,
            'Ciudad': p.ciudad,
            'Puesto': p.puesto,
            'Nivel educativo': p.nivelEducativo,
            '¿Cómo se enteró?': p.comoSeEntero,
            'Interés': p.interes,
            'Fecha asistencia': p.fechaAsistencia ? formatDateHourMinute(p.fechaAsistencia) : '',
            'Fecha de registro': p.fechaAlta ? formatDateHourMinute(p.fechaAlta) : '',
        }))

        const worksheet = XLSX.utils.json_to_sheet(data)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Participantes')
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
        const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' })
        saveAs(dataBlob, 'participantes.xlsx')
    }

    return { exportToExcel }
}

export default useExcelExportRegistro
